import { useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import { useCalculations } from './calculations-context';
import {
  prepareCalculationsFields,
  prepareCalculatorFields,
  prepareSubmitFormFields
} from './components/email-submit-popup/utils';
import { useCalculatorConditionalLogic } from './conditional-logic-context';
import { useFieldsScope } from './use-fields-scope';

export function useEmailSubmitPopupFields() {
  const {
    calculatorEmailSubmitFields,
    fields: settingsFields,
    calculations: settingsCalculations,
    thousandsSeparator,
    decimalSeparator
  } = useSettings();

  const { displayedCalculations, displayedFields: displayedCalculatorFields } =
    useCalculatorConditionalLogic();
  const calculations = useCalculations();
  const fieldsScope = useFieldsScope();

  const preparedSubmitFormFields = useMemo(
    () => prepareSubmitFormFields(calculatorEmailSubmitFields),
    [calculatorEmailSubmitFields]
  );

  const preparedFields = useMemo(() => {
    const preparedCalculatorFormFields = prepareCalculatorFields({
      fields: settingsFields,
      displayedFields: displayedCalculatorFields,
      fieldsScope,
      thousandsSeparator,
      decimalSeparator
    });

    const preparedCalculationsFormFields = prepareCalculationsFields({
      fields: settingsCalculations,
      displayedFields: displayedCalculations,
      calculations,
      thousandsSeparator,
      decimalSeparator
    });

    return [
      ...preparedSubmitFormFields,
      ...preparedCalculatorFormFields,
      ...preparedCalculationsFormFields
    ];
  }, [
    preparedSubmitFormFields,
    settingsFields,
    displayedCalculatorFields,
    fieldsScope,
    thousandsSeparator,
    decimalSeparator,
    settingsCalculations,
    displayedCalculations,
    calculations
  ]);

  return { formFields: preparedSubmitFormFields, allFields: preparedFields };
}
